<template>
    <div class="address_content" :style='overheight'>
     
        <div class='address_title' v-if='!adrShow'>
            <p v-if='false'>{{sendFrom.sendType==10?'包拯地址':'取件地址'}}</p>
            <div class='tel_content' @click='adrshowAction'>
                <div v-show='sendFrom.sendType==10' @click='adrshowAction'>包拯工作室 17526857604 </div>
                <div v-show='sendFrom.sendType == 40' @click='adrshowAction'>
                    {{defultAdr.contacts}}  {{defultAdr.mobile}}
                </div>
                <div v-if='sendFrom.sendType == 40 && JSON.stringify(defultAdr) == "{}"' @click.stop="$router.push({ name: 'addressEdit',query:{ins:'bag'}})"> 
                    <span class='addAdr'>新建地址</span>
                    <img src='/images/public/arrow-right.png'>
                    
                </div>
                <img src='/images/public/arrow-right.png' @click='adrshowAction' v-else>
            </div>
            <div  @click='adrshowAction'>
                
                {{defultAdr.province}}{{defultAdr.city}}{{defultAdr.district}}{{defultAdr.address}}
            </div>
           
        </div>

        <div class='choseType' v-if='sendFrom.sendType!=10 && false' @click="timeShowAction">
            <div class='expressTypeTitle'>
                上门取件时间
            </div>
            <div class='expressTypeTitle'>
                {{pickingDateFormShow}}    {{pickingDateForm.time}}
                <img src='/images/public/more.png'>
            </div>
            
        </div>

        <van-popup position="bottom" v-model="adrShow" overlay-class='overlay'>
            <div class="containerAdr f28">
                <div class="ctitle">{{sendFrom.sendType==10?'邮递地址':'选择地址'}}</div>
         
                <div class="close" @click="adrshowHide"></div>
                <div class="addr-container">
                    <ul v-if='sendFrom.sendType==40'>
                        <li v-for='(item,index) in adrList' :key='index' @click='adrClick(index)'>
                            <div class='li_div'>
                                <radio :checked='item.isDefault'/>
                            </div>
                            <addr-com :model='item' :selected='item.trueDefault' :ins='"bag"' @toEditAdr="$router.push({ name: 'addressEdit',query:{aid:item.id}})"/>
                        </li>
                    </ul>
                

                </div>
               
                
            </div>
            <!-- <div class='adrTips'>*{{$store.state.takeSendCity}}、沈阳、重庆{{$store.state.takeSendNum}}城包邮</div> -->
            <button class="primary fr outsideBtn" @click="$router.push({ name: 'addressEdit',query:{ins:'bag'}})" v-show='sendFrom.sendType==40'>添加地址</button>
          
        </van-popup>
    </div>
</template>

<script>
    import myApi from '@/axios/my'
    import homeApi from '@/axios/home'
    export default {
        name: 'select-address1',
        props: {
            sendFrom: {
                type: Object,
                default:function(){
                    return {
                        sendType : 40,
                        customerAddressId : '',
                        pickingDate : '',
                        pickingTime : '',
                    }
                }
            },
        },
        data () {
            return {

                pickDateList : [],
                pickTimeList : [],
                showpickDateList : [
                    {
                        values: [],
                    },
                    {
                        values: [],
                    }
                ],
                pickingDateForm:{
                    data : '',
                    time : ''
                },
                pickingDateFormShow:'',
                adrList : [],
                timeShow : false,
                adrShow : false,
                actionNow : false,
                overheight : {
                    height : '100px'
                }
            }
        },
        computed: {
            defultAdr(){
                let items = '';
                this.adrList.forEach((item,index)=>{
                    if(item.isDefault){
                        items = item;
                    }
                })
                if(items){
                    this.$emit('changeAdr',items)
                    return items;
                }else{
                    this.$emit('changeAdr',{})
                    return {};
                }
            }
        },
        created () {
            this.getAdressList();
            this.listPickDateAndTime();
        },  
        methods: {
            adrshowAction(){
                if(this.sendFrom.sendType == 40 && JSON.stringify(this.defultAdr) == "{}"){
                    this.$router.push({ name: 'addressEdit',query:{ins:'bag'}});
                    return;
                }
                
                this.adrShow = true;
                this.overheight = {
                    height : '500px'
                }
                this.$emit('showShade');
            },
            adrshowHide(){
                this.adrShow = false;
                this.overheight = {
                    height : '100px'
                }
                this.$emit('hiddenShade');
            },
            timeShowAction(index){
                if(index == 1){
                    this.actionNow = true;
                }else{
                    this.actionNow = false;
                }
                this.timeShow = true;
                this.$emit('showShade');
            },
            timeShowHide(){
                this.timeShow = false;
                this.$emit('hiddenShade');
            },
            adrClick(index){
                this.adrList.forEach((element,idx) => {
                    if(index == idx){
                        element.isDefault = true;
                        
                    }else{
                        element.isDefault = false;
                    }
                });
                // this.adrShow = false;
                this.adrshowHide();
            },
            onConfirm(value, index){
                this.pickDateList.forEach((item,index)=>{
                    if(value[0] == item.pickDateText){
                        this.pickingDateForm.data = item.pickDate;
                        this.pickingDateForm.time = value[1];
                        this.pickingDateFormShow = item.pickDateText;
                        this.$emit('changeDate',item.pickDate,value[1]);
                    }
                });
                
                // this.timeShow = false;
                this.timeShowHide();
                console.log(this.actionNow)
                if(this.actionNow){
                    this.$emit('action')
                }
            },
            onTimeChange(picker, values , index){
                //改变第一列
                if(index == 0){
                    //获取到data重新拉去数据
                    this.pickDateList.forEach((item,index)=>{
                        if(values[0] == item.pickDateText){
                            this.listPickDateAndTime(item.pickDate,picker);
                        }
                    })
                }
            },
            listPickDateAndTime(data,picker){
                let params = {

                }
                if(data){
                    params.pickDate = data;
                }
                homeApi.listPickDateAndTime(params).then((res)=>{
                    this.pickDateList = res.pickDateList;
                    this.pickTimeList = res.pickTimeList;
               
                    if(this.showpickDateList[0].values.length != this.pickDateList.length){
                        let arr = [];
                        this.pickDateList.forEach((item,index)=>{
                            arr.push(item.pickDateText);
                        })
                        this.showpickDateList[0].values = arr;
                    }

                    let arr1 = [];
                    this.pickTimeList.forEach((item,index)=>{
                        arr1.push(item);
                    })
                    
                    if(picker){
                        picker.setColumnValues(1,arr1);
                    }else{
                        this.showpickDateList[1].values = arr1;
                    }
                
                })

            },
            changeType(type){
                // this.sendType = type;
                this.$emit('changeType',type);
        
            },
            checkImg(index){
                return this.sendFrom.sendType==index?2:1
            },
            getAdressList(){
                myApi.customerAddress({}).then((res)=>{
                    let defaultNum = 0;
                    let index = 0;
                    let mostTime = '1970-01-01'
                    res.forEach((element,index)=>{
                        element.trueDefault = element.isDefault;
                        if(element.isDefault){
                            defaultNum++;
                        }
                        let mostDate = new Date(mostTime).getTime();
                        let elementDate = new Date(element.updateTime).getTime();
                        if(elementDate>mostDate){
                            mostTime = element.updateTime;
                            index = index;
                        }
                    })

                    if(defaultNum == 0 && res[index]){
                        res[index].isDefault = true;
                    }

                    this.adrList = res;
                    
                })
            },
        },
    }
</script>

<style scoped lang="scss">
    .overlay{
        // position:fixed;
        // height: 800px;
        // background: red;
    }
    .addAdr{
        margin-right: 20px;
        line-height: 40px;
        position: relative;
        top:-6px;
    }
    .outsideBtn{
        margin-bottom: 20px;
        margin-top: 20px;
        float: right;
        margin-right:30px;
    }
    .tel_content{
        display: flex;
        justify-content: space-between;
        margin-top: 40px!important;
        img{
            width:14px;
            height: 24px;
        }
    }
    .active{
        border: 1px solid #7ADFDF!important;
        span{
            color:#7ADFDF!important;
        }
    }
    .triangle-bottomright {
        width: 0;
        height: 0;
        border-bottom: 40px solid #7ADFDF;
        border-left: 40px solid transparent;
        position: absolute;
        bottom:0;
        right: 0;
    }
    .address_content{
        padding: 40px;
        padding-bottom: 20px;
        // height: 900px;

        .type{
            display: flex;
            justify-content: space-between;
            div{
                width: 48%;
                border-radius:10px;
                height: 94px;
                border: 1px solid #C9C8C8;
                position: relative;
                text-align: center;
                display: flex;
                justify-content:center;
                align-items: center;
                // vertical-align: center;
                // padding-top: 40px;
                img{
                    width: 50px;
                    height: 50px;
                    // margin-top: 20px;
                    margin-right:22px;
                }
                span{
                    line-height: 50px;
                    font-size:28px;
                    color:#C9C8C8;
                }
            }
        }
    }
    .address_title{
        p{
            font-size: 36px;
            color:#4A4A4A;
            font-weight:600;
            margin-top: 40px;
        }
        &>div{
            margin-top: 20px;
            margin-bottom: 20px;
        }
    }
    .choseType{
      
        color:#4A4A4A;
        font-size: 28px;
        display: flex;
        justify-content:space-between;
        line-height: 28px;
        margin-top: 30px;
        padding-right:50px;
        padding-top: 20px;
        // font-weight:600;
        position: relative; 
        border-top: 1px solid #eee;
        .expressTypeTitle{
            color:#4A4A4A;
       
            font-size: 24px;
            line-height: 50px;
        }
        img{
            width:35px;
            position: absolute;
            right: 0;
            top:40px;
        }
    }
    .containerAdr{
        max-height: 860px;
        padding: 32px;
        position: relative;
        padding-bottom:60px;
        padding-top: 0px;

        .ctitle{
            line-height: 90px;
            border-bottom:1px solid #EEEEEE;
            font-size: 28px;
            font-weight:500
            }
            &>span{
                position:absolute;
                right:30px;
                top:80px;
                color:#7ADFDF;
            }
            .addr-container{
                max-height: 700px;
                overflow-y: scroll;
            ul li{
                width: 100%;
                display: flex;
                padding-top:32px;

                // align-items: center;
            }
        }
        .close{
            width: 36px;
            height: 36px;
            position: absolute;
            top: 30px;
            right: 30px;
            background: url("/images/public/close.png") no-repeat center;
            background-size: 32px;
        }
        .submit{
            position: absolute;
            bottom: 30px;
            right: 30px;
        }
    }
    .adrTips{
        background: #F3FBFB;
        padding:16px 30px;
        color:#4A4A4A;
        font-size: 24px;
        line-height: 40px;
    }
    .myadrcontent{
            width:670px;
            margin-bottom: 50px;
            background:rgba(255,255,255,1);
            box-shadow:0px 1px 10px 0px rgba(0,0,0,0.1);
            border-radius:3px;
            padding-top:50px;
            padding-bottom:50px;
            margin-top:30px;
            margin-left: 5px;
        p{
            font-size: 30px;
            margin-bottom: 20px;
            margin-top:20px;
            margin-left:50px; 
        }
    }
</style>
